import { render, staticRenderFns } from "./BreadCrumbItem.vue?vue&type=template&id=5f6d7c11&scoped=true"
import script from "./BreadCrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadCrumbItem.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumbItem.vue?vue&type=style&index=0&id=5f6d7c11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d7c11",
  null
  
)

export default component.exports